/**
 * Tiny relative-time formatter for the Cards tab.
 *
 * No `date-fns` here — keeps the client bundle slim and gives us the
 * exact phrasing our copy calls for ("Joined today", "Joined 2 weeks ago").
 */
export function formatJoinedAgo(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  const diffMs = now.getTime() - then.getTime();
  if (diffMs < 0) return "Joined just now";

  const sec = Math.floor(diffMs / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);

  if (day < 1) return "Joined today";
  if (day === 1) return "Joined yesterday";
  if (day < 7) return `Joined ${day} days ago`;
  if (day < 30) {
    const weeks = Math.floor(day / 7);
    return `Joined ${weeks} ${weeks === 1 ? "week" : "weeks"} ago`;
  }
  if (day < 365) {
    const months = Math.floor(day / 30);
    return `Joined ${months} ${months === 1 ? "month" : "months"} ago`;
  }
  const years = Math.floor(day / 365);
  return `Joined ${years} ${years === 1 ? "year" : "years"} ago`;
}
